// ServiceOne component - Converted from components/ServiceOne.vue
// Services section displaying service cards
import React from 'react';
import { Link } from 'react-router-dom';
import leafImg from '../assets/images/resources/leaf.png';
import serviceImg1 from '../assets/images/service/1.png';
import serviceImg2 from '../assets/images/service/2.png';
import serviceImg3 from '../assets/images/service/3.png';
import serviceImg4 from '../assets/images/service/4.png';

interface Service {
  title: string;
  description: string;
  image: string;
}

const ServiceOne: React.FC = () => {
  // Services data aligned with French Figma copy
  const services: Service[] = [
    {
      title: "Cultures maraîchères",
      description:
        "Les cultures maraîchères regroupent une diversité de légumes cultivés en plein champ, favorisant une alimentation locale et fraîche tout au long de l'année.",
      image: serviceImg1
    },
    {
      title: "La production sous serre",
      description:
        "Cela permet de contrôler l'environnement de culture pour assurer une croissance optimale des plantes, peu importe les conditions extérieures.",
      image: serviceImg2
    },
    {
      title: "Olivier",
      description:
        "Nous nous engageons à cultiver des oliviers de qualité supérieure, en utilisant des méthodes agricoles durables pour produire une huile d'olive extra vierge d'exception.",
      image: serviceImg3
    },
    {
      title: "Les céréales bio",
      description:
        "Les céréales bio sont cultivées sans glyphosate, préservant ainsi l’environnement et la santé des consommateurs.",
      image: serviceImg4
    }
  ];

  return (
    <section className="service_one">
      <div className="container-fluid service_one__container">
        <div className="block-title text-center">
          <p>Ce que nous faisons</p>
          <h3>Services que nous offrons</h3>
          <div className="leaf">
            <img src={leafImg} alt="Decorative leaf" />
          </div>
        </div>
        <div className="row">
          {services.map((service, index) => (
            <div key={index} className="col-xl-3 col-lg-6 col-md-6 col-12">
              <div 
                className="service_1_single wow fadeInUp" 
                data-wow-delay={`${(index + 1) * 100}ms`}
              >
                <div className="content service_1_content">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
                <div className="service_1_img">
                  <img src={service.image} alt={service.title} />
                  <div className="hover_box">
                    <Link to="/service-detail">
                      <span className="icon-left-arrow"></span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceOne;
